import Swiper, { Navigation } from "swiper";

Swiper.use([Navigation]);

$(document).ready(function ($) {
  $(".js-slider-reel").each(function (i, slider) {
    const $slider = $(slider);
    const reelSwiper = new Swiper(slider.querySelector(".swiper"), {
      slidesPerView: "auto",
      resistanceRatio: 0,
      spaceBetween: 12,
      effect: "fade",

      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev"),
      },
    });

    if (
      $(this).children(".slider__clip").children(".slider__slides")[0]
        .scrollWidth <= $slider.outerWidth()
    ) {
      $slider.addClass("hide-controls");
    }

    $(window).on("load", function () {
      reelSwiper.update();
    });
  });

  $(".js-slider-tests").each(function (i, slider) {
    const $slider = $(slider);
    const $sliderLength = $slider.find(".slider__slide").length;

    if ($sliderLength < 5) {
      $slider.addClass("hide-controls");
    }

    const swiper = new Swiper(slider.querySelector(".swiper"), {
      slidesPerView: 1,
      resistanceRatio: 0,
      spaceBetween: 37,
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        575: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      },
    });
  });

  $(".js-slider-filter").each(function (i, slider) {
    const $slider = $(slider);

    const filterSwiper = new Swiper(slider.querySelector(".swiper"), {
      slidesPerView: "auto",
      resistanceRatio: 0,
      spaceBetween: 9,
    });

    $(window).on("load", function () {
      filterSwiper.update();
    });
  });
});
